module.exports = __webpack_public_path__ + "img/liantong.3fdab818.png";